import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    signInWrapper: InjectableCss;
    cartWrapper: InjectableCss;
    linksWrapper: InjectableCss;
    links: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            height: 5rem;
            > * + * {
                margin: 0 0 0 1.875rem;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0 1rem;
                        `,
                        null,
                        null,
                        css`
                            padding: 0 5rem;
                        `,
                        null,
                    ],
                    "min",
                );
            }}
        `,
    },
    logoWrapper: {
        css: css`
            display: flex;
            align-items: center;
            max-width: 170px;
            flex: 1;
            flex-shrink: 0;
            div {
                max-width: 166px;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                height: 78px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                height: 42px;
                                width: auto;
                                margin: 0;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            flex: 1;
            flex-shrink: 0;
            padding-right: 50px;
            div[class^="FormFieldStyle-sc"] {
                width: 100%;
            }
            display: flex;
            align-items: center;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        css`
                            flex-grow: 8;
                        `,
                        css`
                            padding-right: 0;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    linksWrapper: {
        css: css`
            flex-shrink: 0;
            display: flex;
            justify-content: flex-end;
            > :first-child {
                [class^="TypographyStyle"] {
                    [class^="TypographyStyle"] {
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        display: none;
                                    `,
                                    null,
                                    null,
                                ],
                                "max",
                            );
                        }}
                    }
                }
            }
        `,
    },
    signInWrapper: {
        css: css`
            height: 100%;
            > div[class^="Wrapper"] {
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                div[class^="sc"] {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        `,
    },
    cartWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    links: {
        css: css`
            display: flex;
            > div {
                display: flex;
                align-items: center;
                > * + * {
                    margin: 0 0 0 1.875rem;
                }
            }
        `,
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...logoLinksSearchStyles.container}>
        <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
            <Zone contentId={id} zoneName="Logo" fixed />
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.searchMenuWrapper}>
            <Zone contentId={id} zoneName="Search" fixed />
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.linksWrapper}>
            <StyledWrapper {...logoLinksSearchStyles.links}>
                <Zone contentId={id} zoneName="headerIconLinks" />
            </StyledWrapper>
            <Hidden below="lg" {...logoLinksSearchStyles.signInWrapper}>
                <Zone contentId={id} zoneName="SignIn" />
            </Hidden>
            <StyledWrapper {...logoLinksSearchStyles.cartWrapper}>
                <Zone contentId={id} zoneName="Cart" />
            </StyledWrapper>
        </StyledWrapper>
    </StyledWrapper>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
